import React, { useState, useEffect } from 'react'
import { Route, Link, useNavigate, useOutletContext } from 'react-router-dom'
import { useAuth } from '../../providers/AuthProvider'

import { Button, IconButton, Tooltip } from '@mui/material'
import AdminFrame from '../AdminFrame'
import { AgGridReact } from 'ag-grid-react'

import Fab from '@mui/material/Fab'
import AddIcon from '@mui/icons-material/Add'

import axios from 'axios'

export default function Questionnaires() {
  const auth = useAuth()
  const navigate = useNavigate()
  const [ questionnaires, setQuestionnaires ] = useState([])
  const [ isLoading, setIsLoading ] = useOutletContext()

  useEffect(() => {
    setIsLoading(true)
    axios.get('/api/questionnaires').then((res) => {
      const formattedData = res.data
      setQuestionnaires(formattedData)
      setIsLoading(false)
      console.log(formattedData)
    }).catch(
      err => {
        console.log(err)
        setIsLoading(false)
      }
    )
  }, [])

  const qnnColDefs = [
    {field: "id", headerName: "ID", flex: 1},
    {field: "company", flex: 2},
    {field: "year", flex: 1},
    {field: "user.email", headerName: "User's Email", flex: 1},
    {field: "total_progress", headerName: "% Done", flex: 1, valueFormatter: (props) => (
      Math.round(props.value * 100) / 100
    )},
    {field: "number_of_questions", headerName: "# of Questions", flex: 1},
    {field: "has_report", headerName: "Report Generated", flex: 1, cellRenderer: (props) => (
      <span>{props.value ? "YES" : 'no'}</span>
    )},
    {field: "id", headerName: "Actions", flex: 1, cellRenderer: (props) => (
      <Button variant="contained" onClick={() => (navigate('/admin/questionnaires/' + props.value))}>Manage</Button>
    )}
  ]

  const autoSizeStrategy = {
    type: 'fitGridWidth'
};

  return(
      <div className="adminPage admin-table-wrapper">

        <header className="pageHeader">
          <h1>Questionnaires</h1>
        </header>

        {!!questionnaires.length && (
          <div className="ag-theme-quartz full-container-table">
            <AgGridReact 
              domLayout='autoHeight'
              suppressDragLeaveHidesColumns 
              rowData={questionnaires} 
              columnDefs={qnnColDefs} 
              autoSizeStrategy={autoSizeStrategy}
              enableCellTextSelection
              ensureDomOrder
            />
          </div>
        )}

      </div>
  )
}
